var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.7617,
    r: 12,
    fill: "#FFC400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 6.76172C11.4877 6.76172 10.9658 7.18911 11.0005 7.78641L11.25 14.5234C11.2531 14.7181 11.3317 14.9042 11.4696 15.042C11.6103 15.1827 11.801 15.2617 11.9999 15.2617C12.1988 15.2617 12.3896 15.1827 12.5303 15.042C12.6681 14.9042 12.7468 14.7181 12.7498 14.5234L12.9994 7.78641C13.0341 7.18911 12.5122 6.76172 11.9999 6.76172ZM12.0097 7.76912C12.0097 7.76912 12.0097 7.76907 12.0096 7.76896L12.0097 7.76912ZM11.9901 7.76912L11.9902 7.76896C11.9902 7.76907 11.9901 7.76912 11.9901 7.76912ZM12 16.7617C11.4477 16.7617 11 17.2094 11 17.7617C11 18.314 11.4477 18.7617 12 18.7617C12.5523 18.7617 13 18.314 13 17.7617C13 17.2094 12.5523 16.7617 12 16.7617Z",
    fill: "#242525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.78607c0a9f5728e1248fd379f8a6a4b0.svg";
export { ForwardRef as ReactComponent };